module.exports = __webpack_public_path__ + "img/ImageNotFound.33efcf4a.jpg";